import axios from 'axios'
import {FC, useState} from 'react'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import {KTSVG} from '../_metronic/helpers'
import {CustomModal} from './CustomModal'
import Skeleton from 'react-loading-skeleton'
import {Row, Col} from 'react-bootstrap'
import {ActionIcon} from './ActionIcon/ActionIcon'
interface DocFlowProps {
  isLoading?: boolean
  id?: number
}

export const DocFlow: FC<DocFlowProps> = (props) => {
  const {t} = useTranslation()
  const [openModal, setOpenModal] = useState(false)
  const [docFlow, setDocFlow] = useState<any[]>([])
  const [tooltip, setTooltip] = useState('Open')
  const [SIP, setSIP] = useState(false)
  const [contract, setContract] = useState(false)
  const [SO, setSO] = useState(false)
  const [retail, setRetail] = useState(false)
  const [arraySO, setArraySO] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleClickDocFlow = () => {
    setIsLoading(true)
    setOpenModal(true)
    axios
      .get(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/doc-flow/${
          props.id
        }?credentials=${localStorage.getItem('credential')}&lang=${i18next.language}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res: any) => {
        const result = res.data.data.find((item: any) => item.name === 'Sales Order')
        if (result) {
          const numbers = result?.number
            .replaceAll(' ', '')
            ?.split(',')
            .map((item: any) => '13' + item)
          setArraySO(numbers)
        }
        setDocFlow(res.data.data)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
  }

  const handleHeaderNumber = (data: string) => {
    if (data === 'Order submission') {
      return '10'
    } else if (data === 'SIP') {
      return '11'
    } else if (data === 'Contract') {
      return '12'
    } else if (data === 'Sales Order') {
      return '13'
    } else {
      return ''
    }
  }

  return (
    <>
      <ActionIcon
        className='me-1'
        title={t('DocFlow')}
        iconPath='/media/icons/duotune/file-bar-graph-fill.svg'
        isLoading={isLoading}
        disabled={isLoading}
        onClick={handleClickDocFlow}
      />

      <CustomModal
        title={t('DocFlow')}
        show={openModal}
        size='lg'
        onHide={() => {
          setOpenModal(false)
          setSIP(false)
          setContract(false)
          setSO(false)
          setRetail(false)
        }}
        centered
      >
        {isLoading ? (
          <>
            <Row>
              <Col lg={4}>
                <Skeleton height={30} />
              </Col>
              <Col lg={4}>
                <Skeleton height={30} />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <div className='table-responsive bdr ms-5'>
              <table className='table table-border-none'>
                <tbody>
                  <table className='table table-border-none'>
                    <tbody className='border-0'>
                      <tr className='d-flex  w-100 align-items-center border-0'>
                        <td className='td-order-3 fs-4 d-flex align-items-center ms-2'>
                          {docFlow[1]?.number && (
                            <button
                              className='iconArow d-flex align-items-center me-2'
                              data-target={'target' + docFlow[0]?.name}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t(tooltip)}
                              onClick={(e: any) => {
                                handleOpen(e)
                                setSIP(!SIP)
                              }}
                            ></button>
                          )}
                          {docFlow[0]?.name}
                        </td>
                        <td className='td-order-2 fs-4'>
                          {docFlow[0]?.name === 'Sales Order' ? (
                            <>
                              {arraySO?.map((item: any) => (
                                <>
                                  <div>{item}</div>
                                </>
                              ))}
                            </>
                          ) : (
                            <>
                              <div>{handleHeaderNumber(docFlow[0]?.name) + docFlow[0]?.number}</div>
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    className='table-responsive bdr'
                    style={{display: `${SIP ? '' : 'none'}`, padding: '0px'}}
                  >
                    <table className='table'>
                      <tbody>
                        <tr
                          className='d-flex  align-items-center border-0'
                          style={{marginLeft: '3rem'}}
                        >
                          <td className='td-order-3 fs-4  d-flex align-items-center'>
                            {docFlow[2]?.number || docFlow[3]?.number ? (
                              <button
                                className='iconArow d-flex align-items-center me-2'
                                data-target={'target' + docFlow[1]?.name}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t(tooltip)}
                                onClick={(e: any) => {
                                  handleOpen(e)
                                  if (docFlow[2]?.number) {
                                    setContract(!contract)
                                  } else {
                                    setSO(!SO)
                                    setRetail(!retail)
                                  }
                                }}
                              ></button>
                            ) : (
                              <></>
                            )}
                            {docFlow[1]?.name}
                          </td>
                          <td className='td-order-2 fs-4'>
                            {docFlow[1]?.name === 'Sales Order' ? (
                              <>
                                {arraySO?.map((item: any) => (
                                  <>
                                    <div>{item}</div>
                                  </>
                                ))}
                              </>
                            ) : (
                              <>
                                <div>
                                  {handleHeaderNumber(docFlow[1]?.name) + docFlow[1]?.number}
                                </div>
                              </>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      className='table-responsive bdr'
                      style={{display: `${contract || SO ? '' : 'none'}`, padding: '0px'}}
                    >
                      <table className='table'>
                        <tbody>
                          <tr
                            className='d-flex  align-items-center border-0'
                            style={{marginLeft: '5rem'}}
                          >
                            <td className='td-order-3 fs-4 d-flex align-items-center'>
                              {docFlow[2]?.number && docFlow[3]?.number ? (
                                <button
                                  className='iconArow d-flex align-items-center me-2'
                                  data-target={
                                    'target' +
                                    (docFlow[2]?.number ? docFlow[2]?.name : docFlow[3]?.name)
                                  }
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t(tooltip)}
                                  onClick={(e: any) => {
                                    handleOpen(e)
                                    setSO(!SO)
                                  }}
                                ></button>
                              ) : (
                                <></>
                              )}
                              {docFlow[2]?.name}
                            </td>
                            <td className='td-order-2 fs-4'>
                              {docFlow[2]?.name === 'Sales Order' ? (
                                <>
                                  {arraySO?.map((item: any) => (
                                    <>
                                      <div>{item}</div>
                                    </>
                                  ))}
                                </>
                              ) : (
                                <>
                                  <div>
                                    {handleHeaderNumber(docFlow[2]?.name) + docFlow[2]?.number}
                                  </div>
                                </>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        className='table-responsive bdr'
                        style={{display: `${SO && !retail ? '' : 'none'}`, padding: '0px'}}
                      >
                        <table className='table'>
                          <tbody>
                            <tr
                              className='d-flex  align-items-start border-0'
                              style={{marginLeft: '7.5rem'}}
                            >
                              <td className='td-order-2 fs-4 d-flex align-items-start ms-4'>
                                {docFlow[3]?.name}
                              </td>
                              <td className='td-order-2 fs-4' style={{marginLeft: '2rem'}}>
                                {arraySO?.map((item: any) => (
                                  <>
                                    <div>{item}</div>
                                  </>
                                ))}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </tbody>
              </table>
            </div>
          </>
        )}
      </CustomModal>
    </>
  )
}
